// Turning processed pages into a billing figure: pages the firm still has to review, at a per-page
// minute estimate and the firm's hourly rate. Fixed assumptions, shown wherever a figure is derived.
export const RATE_PER_HOUR = 200
export const MINUTES_PER_PAGE = 5

export const billableHours = (pages: number): number =>
  (pages * MINUTES_PER_PAGE) / 60

export const billableAmount = (pages: number): number =>
  billableHours(pages) * RATE_PER_HOUR
